import React from 'react';

const Blogs = () => {
    return (
        <div className="row mt-5 justify-content-between">
            <div className="col-lg-5 border rounded-3 p-5">
                <h1 className="title">What is the purpose of context API?</h1>
                <p>
                    The React Context API is a component structure provided by the React framework, which enables us to share specific forms of data across all levels of the application.
                    The Context API is a way for a React app to effectively produce global variables that can be passed around.
                    The Context API has actually always been there but was considered experimental. Moving forward the API was improved to stability, and as of the release of version 16.3,
                    the feature was made available and subsequently considered a new addition to the clan of features that make React a wonderful framework.
                    React.createContext() is all you need. It returns a consumer and a provider. Provider is a component that as it's names suggests provides the state to its children.
                    It will hold the "store" and be the parent of all the components that might need that store.
                    Consumer as it so happens is a component that consumes and uses the state.
                </p>
            </div>
            <div className="col-lg-5 border rounded-3 p-5">
                <h1 className="title">What is Semantic tag?</h1>
                <p>
                    HTML5 semantic tags define the purpose of the element.
                    By using semantic markup, that help the browser understand the meaning of the content instead of just displaying it.
                    When a browser communicates with the code, it looks for some specific information to help with the display.
                    HTML5 semantic elements also help search engines to read the page and  find the required information faster.
                    In earlier versions of HTML, there were no globally accepted names for structural elements, and each developer used their own.
                    That made it very hard for search engines to index web page content correctly.In HTML5 semantic tag providing the extra level of clarity of elements.
                </p>
            </div>
        </div>
    );
};

export default Blogs;